import {NgModule} from "@angular/core";
import {MedlemInvitasjonOpprettKomponentAvhengigheter} from "web-ng2/moduler/medlem/komponenter/medlem-invitasjon-opprett/medlem-invitasjon-opprett";
import {MedlemInvitasjonRedigerKomponentAvhengigheter} from "web-ng2/moduler/medlem/komponenter/medlem-invitasjon-rediger/medlem-invitasjon-rediger";
import {MedlemImporterFraGruppeKomponentAvhengigheter} from "web-ng2/moduler/medlem/importer-medlemmer/komponenter/medlem-importer-fra-gruppe/medlem-importer-fra-gruppe";
import {MedlemImporterDialogKomponentAvhengigheter} from "web-ng2/moduler/medlem/importer-medlemmer/modale/medlem-importer-dialog/medlem-importer-dialog";
import {MedlemRedigerKomponentAvhengigheter} from "web-ng2/moduler/medlem/komponenter/medlem-rediger/medlem-rediger";
import {MedlemStengTilgangBekreftelseKomponentAvhengigheter} from "web-ng2/moduler/medlem/komponenter/medlem-steng-tilgang-bekreftelse/medlem-steng-tilgang-bekreftelse";
import {MedlemStengTilgangDialogKomponentAvhengigheter} from "web-ng2/moduler/medlem/modale/medlem-stengtilgang-dialog/medlem-stengtilgang-dialog";
import {MedlemGjenåpneTilgangDialogKomponentAvhengigheter} from "web-ng2/moduler/medlem/modale/medlem-gjenåpnetilgang-dialog/medlem-gjenåpnetilgang-dialog";
import {MedlemAnonymiserDialogKomponentAvhengigheter} from "web-ng2/moduler/medlem/modale/medlem-anonymiser-dialog/medlem-anonymiser-dialog";
import {MedlemmerVisKomponentAvhengigheter} from "web-ng2/moduler/medlem/komponenter/medlemmer-vis/medlemmer-vis";
import {MedlemInvitasjonKortKomponentAvhengigheter} from "web-ng2/moduler/medlem/komponenter/medlem-invitasjon-kort/medlem-invitasjon-kort";
import {MedlemmerListKomponentAvhengigheter} from "web-ng2/moduler/medlem/komponenter/medlemmer-list/medlemmer-list";

@NgModule({
    providers: [
        MedlemInvitasjonOpprettKomponentAvhengigheter,
        MedlemInvitasjonRedigerKomponentAvhengigheter,
        MedlemImporterFraGruppeKomponentAvhengigheter,
        MedlemImporterDialogKomponentAvhengigheter,
        MedlemRedigerKomponentAvhengigheter,
        MedlemStengTilgangDialogKomponentAvhengigheter,
        MedlemStengTilgangBekreftelseKomponentAvhengigheter,
        MedlemGjenåpneTilgangDialogKomponentAvhengigheter,
        MedlemAnonymiserDialogKomponentAvhengigheter,
        MedlemmerVisKomponentAvhengigheter,
        MedlemInvitasjonKortKomponentAvhengigheter,
        MedlemmerListKomponentAvhengigheter
    ]
})
export class MedlemModul{

}
